import Edit from '../../../../shared/Icons/Edit';
import Delete from '../../../../shared/Icons/Delete';
import See from '../../../../shared/Icons/See';
import AsyncButton from '../../../../shared/Loading/AsyncButton';

const Row = ({
  user,
  isEliminator,
  isEditor,
  selected,
  toggleOne,
  editUser,
  askDelete
}) => {
  const isChecked = selected.has(user.Id);
  return (
    <tr className="hover:bg-gray-50">
      {isEliminator && (
        <td className="lg:px-4 md:px-2 py-4">
          <input
            type="checkbox"
            className="h-4 w-4 accent-personalized"
            checked={isChecked}
            onChange={() => toggleOne(user.Id)}
          />
        </td>
      )}
      <td className={`py-4 whitespace-normal text-sm font-medium break-words text-gray-900 ${!isEliminator ? 'px-6' : ''}`}>
        {user?.FirstName} {user?.LastName}
      </td>
      <td className="py-4 whitespace-nowrap text-sm text-gray-500 overflow-hidden">
        {user?.PrincipalEmail}
      </td>
      <td className="py-4 whitespace-nowrap text-sm text-gray-500 overflow-hidden text-ellipsis">
        {user?.AlternativeEmail}
      </td>
      <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
        {user.Role === 'Usuario' ? (user?.Score ?? 0) : '-'}
      </td>
      <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
        {user.Role === 'Usuario' ? (user?.Level ?? 0) : '-'}
      </td>
      <td className="py-4 whitespace-nowrap text-sm text-gray-500">
        <div className="flex gap-2 pr-4">
          <AsyncButton
            onClick={() => editUser(user)}
            className="inline-flex items-center justify-center w-8 h-8 text-white rounded bg-personalized hover:bg-purple-500"
            title={isEditor ? 'Editar' : 'Ver'}
          >
            {isEditor ? <Edit/> : <See/>}
          </AsyncButton>
          {isEliminator && (
            <AsyncButton
              onClick={() =>
                askDelete(
                  [user.Id],
                  `¿Eliminar a ${user.FirstName} ${user.LastName}? Esta acción no se puede deshacer`
                )
              }
              className="inline-flex items-center justify-center w-8 h-8 text-white rounded bg-red-600 hover:bg-red-400"
              title="Eliminar"
            >
              <Delete />
            </AsyncButton>
          )}
        </div>
      </td>
    </tr>
  );
};

export default Row;
